import {Component, DestroyRef, inject, OnDestroy, OnInit, ViewChild} from "@angular/core";
import {UtilsService} from "../../../../core/utils/utils.service";
import {ProductionService} from "../../../../core/services/gestion-production/production.service";
import {Auth2Service} from "../../../../core/services/security/auth2.service";
import {from, Subscription} from "rxjs";
import {finalize} from "rxjs/operators";
import {takeUntilDestroyed} from "@angular/core/rxjs-interop";
import {ActivatedRoute} from "@angular/router";
import {
  DATEPICKER_FR,
  FP_ROUTES,
  FS_ROUTES,
  HELP_FOLDERS,
  MSG_KEY,
  MSG_SEVERITY,
  PRINT_MODE,
  PRINT_SUBJECT,
  UI_COLORS
} from "../../../../core/constants";
import {PlanProductionDTO} from "../../../../core/dtos/plan-production-dto";
import {RoutemapService} from "../../../../core/services/routemap.service";
import {PlanProductionDetailDTO} from "../../../../core/dtos/plan-production-detail-dto";
import {ResponseWrapper} from "../../../../core/suppliers/wrappers/response-wrapper";
import {ListeBesoinsDto} from "../../../../core/dtos/liste-besoins-dto";
import {ListeBesoinsService} from "../../../../core/services/entities/liste-besoins.service";
import {DATAGRID_ROW_TYPES} from "../../../../core/services/technique/devextreme.service";
import {UniteDeProduction__EquipeDTO} from "../../../../core/dtos/unite-de-production__equipe";
import {BulkDetailSupplier} from "../grid-details-pp/bulk-edition-details-dialog/bulk-edition-details-dialog.component";
import DataSource from "devextreme/data/data_source";
import ArrayStore from "devextreme/data/array_store";
import {FamilleProduitDTO} from "../../../../core/dtos/famille-produit-dto";
import {DxDataGridComponent, DxTreeViewComponent} from "devextreme-angular";
import {PreparationConditionnementService} from "../../../../core/services/conditionnements/preparation-conditionnement.service";
import {Workbook} from "exceljs";
import {exportDataGrid} from "devextreme/excel_exporter";
import {saveAs} from 'file-saver-es';
import {SimulationStockDTO} from "../../../../core/dtos/gestion-production/simulation-stock-dto";
import {PrintMenuService} from "../../../../core/services/gestionmenus/print-menu.service";
import BonLivraisonSettingsMl from "../../../../core/dtos/conditionnement/bon-livraison-settings-ml";
import {BonAllotGroupingOrder} from "../../../../core/enums/bon-allotissement-grouping-enum";
import {PointDeLivraisonDTO} from "../../../../core/dtos/point-de-livraison-d-t-o";
import {StepSimulationStockDTO} from "../../../../core/dtos/gestion-production/step-simulation-stock-dto";
import {BonAllotissementSortingEnum} from "../../../../core/enums/bon-allotissement-sorting-enum";
import BonAllotissementSettingsMl from "../../../../core/dtos/conditionnement/bon-allotissement-settings-ml";
import {MessageService} from "primeng/api";
import {confirm} from "devextreme/ui/dialog";
import {ToastService} from "../../../../core/services/technique/toast.service";
import {FermeturePoncutelleService} from "../../../../core/services/entities/fermeture-poncutelle.service";
import {FermeturePonctuelleDTO} from "../../../../core/dtos/fermeture-ponctuelle/FermeturePonctuelleDTO";
import {FermeturePonctuelleFilter} from "../../../../core/dtos/fermeture-ponctuelle/FermeturePonctuelleFilter";
import ConditionnementLivraisonFermetureMl from "../../../../core/dtos/conditionnement/conditionnement-livraison-fermeture-ml";
import {ButtonThemeEnum} from '../../../../shared/ui/button/button-theme-enum';

@Component({
    selector: 'yo-plan-production',
    templateUrl: './plan-production.component.html',
    styleUrls: ['./plan-production.component.scss'],
    standalone: false
})
export class PlanProductionComponent implements OnInit, OnDestroy {

  public readonly ButtonThemeEnum = ButtonThemeEnum;


  private subRoute: Subscription;
  private massiveTreatmentSub: Subscription;
  private subSearchPlanProduction: Subscription;
  private subPlanProd: Subscription;
  private subPrintErrorsBonlivraison: Subscription;
  private subPrintErrorsBonAllotissement: Subscription;
  private subDateConditionnementError : Subscription
  private subPrintErrorsBonConditionnement: Subscription;
  private dateConditionnementError: boolean = false;
  conditionnementDateErrorList: any[] = [];
  livraisonDateErrorList: ConditionnementLivraisonFermetureMl[] = [];
  selectedLivraisonDateErrors: ConditionnementLivraisonFermetureMl[] = [];
  bulkSwitchingDate: Date = null;
  private subErrors: Subscription;
  subCleanCalculInProgress: Subscription;
  private subscriptionCalcul: Subscription;
  private totalAndTraca: boolean;
  printErrors: Object[];
  private idPlanProduction: number;
  private printMode: PRINT_MODE;
  private settings: BonLivraisonSettingsMl;
  private grouping: BonAllotGroupingOrder;
  private bonAllotissementSettings: BonAllotissementSettingsMl;
  readonly $destroyRef = inject(DestroyRef);

  loadingVisible: boolean;
  loadingMessage: string = '';
  displayCalculSuccess = false;


  private printSubject: PRINT_SUBJECT;
  popupErrorsTitle: string;
  errors: any = [];
  plcsNotTakenAccount: PointDeLivraisonDTO[];

  displayBonErrors: boolean = false;

  displayConditionnementDateErrorMessage: boolean = false;

  displayLivraisonDateErrorMessage: boolean = false;

  displayDateConditionnementErrorList: boolean = false;

  avoidQuantityZero: Boolean = true;

  localeFr = DATEPICKER_FR;

  planProduction: PlanProductionDTO = new PlanProductionDTO();

  pathFile: string = HELP_FOLDERS.PLANS_PRODUCTION + '/plan-production';

  currentEffectif: string;

  selectedDetails: PlanProductionDetailDTO[] = [];

  displayOptionsGenerationListeBesoinDialog: boolean;

  newLabelListeBesoin: string;
  famillesPlats: FamilleProduitDTO[] = [];
  selectedFamillesPlats: number[] = [];

  filtersLbde: any;

  displayPrintSettingsFichesTechniques: boolean = false;
  datesConso: Date[] = [];
  datesFab: Date[] = [];
  teams: UniteDeProduction__EquipeDTO[] = [];
  dishesParents: any[] = [];

  displayOnlyMainRecipes: boolean = false;
  displayOptionsDisplayDialog: boolean = false;
  displayParentsDishesDialog: boolean = false;

  valueTeam: boolean = true;
  valuePlc: boolean = true;
  valueMeal: boolean = true;
  valueConsumptionDate: boolean = true;

  columnNameNbParts: string = 'nbParts';
  columnNameNbPartsArrondi: string = 'nbPartsArrondi';
  columnNameDateFab: string = 'dateFab';
  columnNameDateDlc: string = 'dlc';
  columnNameEquipe: string = 'equipe.libelle';

  dataSourceTeams: any;

  idsFournisseursSelected: number[] = [];

  idsTachesSelected: number[] = [];

  @ViewChild(DxTreeViewComponent, {static: false}) treeView;
  @ViewChild(DxDataGridComponent, {static: false}) gridDetailPlanProd;

  displayDenreesWithoutItems: boolean = false;

  displayDenreesWithRatiosMisconfigured: boolean = false;

  denreesWithoutItems: any[] = [];

  denreesWithRatiosMisconfigured: any[] = [];

  isDataRetrieved: boolean = false;

  private isPopupOpened: boolean = false;

  @ViewChild('grid') grid: DxDataGridComponent;

  titleButtonForceGeneration: string;
  typeGeneration: string;

  displaySimulationStocks: boolean = false;
  simulationStocks: SimulationStockDTO[] = [];
  simulationStocksInitial: SimulationStockDTO[] = [];
  selectedSimulationStock: SimulationStockDTO;
  dateMin: Date;
  dateMax: Date;

  page: any = 1;
  pageSize: any = 50;
  idPlanProductionDetails: number[];

  searchDenree: string;

  tooltipData: string;
  tooltipVisible: boolean = false;
  tooltipTarget: any;
  sorting: BonAllotissementSortingEnum;
  hasIDistri: boolean = false;
  fermeturePonctuelleList: FermeturePonctuelleDTO[] = [];

  constructor(public readonly utils: UtilsService,
              private readonly route: ActivatedRoute,
              private readonly prodSvc: ProductionService,
              private readonly routeMapSvc: RoutemapService,
              private readonly auth2Svc: Auth2Service,
              private readonly lbSvc: ListeBesoinsService,
              private readonly pcSvc: PreparationConditionnementService,
              private printMenuSvc: PrintMenuService,
              private preparationConditionnementSvc: PreparationConditionnementService,
              private msgSvc: MessageService,
              private toastSvc: ToastService,
              private fermeturePonctuelleSvc: FermeturePoncutelleService
  ) {
  }

  ngOnDestroy(): void {
    this.utils.unsubscribe(this.subRoute);
    this.utils.unsubscribe(this.massiveTreatmentSub);
    this.utils.unsubscribe(this.subPlanProd);
    this.utils.unsubscribe(this.subSearchPlanProduction);
    this.utils.unsubscribe(this.subPrintErrorsBonlivraison);
    this.utils.unsubscribe(this.subErrors);
    this.utils.unsubscribe(this.subCleanCalculInProgress);
    this.utils.unsubscribe(this.subPrintErrorsBonAllotissement);
    this.utils.unsubscribe(this.subDateConditionnementError);
    this.utils.unsubscribe(this.subPrintErrorsBonConditionnement);
  }

  ngOnInit(): void {
    this.initSubscriptions();
    this.initPrintErrors();
  }

  formatDate = (date: Date): string | null => date ? this.utils.getDateDDMMYYYY(date) : null;

  onEditorPreparing = (event: any) => {
    this.updateLoadingPopup();
    if (event.parentType === 'dataRow' && event.editorName !== 'dxCheckBox') {
      const self = this;
      const currentRow = event.row.data;

      if (currentRow.hasSortie === true) {
        event.editorOptions.disabled = true;
        return;
      }

      event.editorOptions.onValueChanged = function (args: any) {
        const dataField: string = event.dataField;
        const tasks: any = {numberDishesToUpdate: null, teamsDatesToUpdate: null};
        if (args.value !== args.previousValue) {
          if (dataField === self.columnNameNbParts) {
            const numberDishesToUpdate: any[] = [{idLine: currentRow.id, subRecipe: currentRow.subRecipe, numbersDishes: args.value}];
            tasks.numberDishesToUpdate = numberDishesToUpdate;
          } else if (dataField === self.columnNameDateFab) {
            const teamsDatesToUpdate: any[] = [{idLine: currentRow.id, subRecipe: currentRow.subRecipe, dateFab: args.value, dateDlc: null, idUdpEquipe: null}];
            tasks.teamsDatesToUpdate = teamsDatesToUpdate;
          } else if (dataField === self.columnNameDateDlc) {
            const teamsDatesToUpdate: any[] = [{idLine: currentRow.id, subRecipe: currentRow.subRecipe, dateFab: null, dateDlc: args.value, idUdpEquipe: null}];
            tasks.teamsDatesToUpdate = teamsDatesToUpdate;
          }
          self.prodSvc.applyMassiveTreatment(self.planProduction.id, tasks)
            .subscribe(() => self.fetchPlanProductionSubscription());
        }
      };
    }
  }

  changeTeam = (value: number, idRow: number): void => {
    const data: PlanProductionDetailDTO = Object.assign({}, this.planProduction.rows.find(x => x.id === idRow));
    const teamsDatesToUpdate: any[] = [{idLine: data.id, subRecipe: data.subRecipe, dateFab: null, dateDlc: null, idUdpEquipe: value}];
    const tasks: any = {teamsDatesToUpdate};
    this.prodSvc.applyMassiveTreatment(this.planProduction.id, tasks)
      .subscribe(() => this.fetchPlanProductionSubscription());
  }

  closeOptionsDisplayDialog = (): void => {
    this.displayOptionsDisplayDialog = false;
  }

  openOptionsDisplayDialog = (): void => {
    this.displayOptionsDisplayDialog = true;
  }

  closeParentsDishes = (): void => {
    this.dishesParents = [];
    this.displayParentsDishesDialog = false;
  }

  displayParentsDishes = (idSubDish: number): void => {
    if (this.valueTeam && this.valuePlc && this.valueMeal && this.valueConsumptionDate) {
      this.prodSvc.getPlanProductionLigneParent(idSubDish)
        .subscribe(response => {
          this.dishesParents = [response.one];
          this.displayParentsDishesDialog = true;
        })
    } else {
      this.toastSvc.displayToast(MSG_KEY.ROOT, MSG_SEVERITY.WARNING, `Veuillez activer les options d'affichage : Equipe, Point de livraison, Repas et Date de consommation pour pouvoir afficher les parents`);
    }
  }

  initSubscriptions = (): void => {
    this.initHasGestionIDistri();
    this.initOnRequest();
    this.fetchPlanProductionSubscription();
    this.massiveTreamtmentSubscription();
    this.initCleanCalculInProgress();
  }

  initCleanCalculInProgress = (): void => {
    this.subCleanCalculInProgress = this.utils.canceledCalculConditionnement$
      .subscribe(() => this.preparationConditionnementSvc.cleanCalculInProgress(this.planProduction.id));
  }

  initOnRequest = () => {
    this.subSearchPlanProduction = this.prodSvc.searchPlanProduction$.subscribe(() => {
      this.isDataRetrieved = false;
      this.updateLoadingPopup();
    })
  }

  fetchDateFermeturePonctuelle = (): void => {
    const filter = new FermeturePonctuelleFilter();
    filter.idUniteProduction = this.planProduction?.unitesDeProductions[0].id;
    filter.perimetre = 'FABRICATION';
    this.fermeturePonctuelleSvc.getFermeturePonctuelle(filter).subscribe(response => {
      this.fermeturePonctuelleList = response;
    });
  }

  fetchFiltersListeBesoins = (): void => {
    this.lbSvc.filtersForListeBesoinFromPlanProduction(this.planProduction?.unitesDeProductions[0].id)
      .subscribe(response => {
        this.filtersLbde = response.one;
        this.famillesPlats = response.one.familles;

        this.isDataRetrieved = true;
        this.updateLoadingPopup();
      });
  }

  applyGrouping = (): void => {
    this.fetchPlanProductionSubscription();
    this.closeOptionsDisplayDialog();
  }

  fetchPlanProductionSubscription = (): void => {
    const pathnameSplitted = window.location.pathname.split("/");
    const idPlanProduction = parseInt(pathnameSplitted[pathnameSplitted.length - 1].replace(")", ""));
    if (!this.valueConsumptionDate && !this.valueMeal && !this.valuePlc && !this.valueTeam) {
      this.valueConsumptionDate = true;
      this.valueMeal = true;
      this.valuePlc = true;
      this.valueTeam = true;
    }
    const filters: any = {
      fetchOnlyMainRecipes: this.displayOnlyMainRecipes,
      groupByTeam: this.valueTeam,
      groupByPlc: this.valuePlc,
      groupByMeal: this.valueMeal,
      groupByConsumptionDate: this.valueConsumptionDate
    };
    this.subPlanProd = this.prodSvc.findById(idPlanProduction, filters)
      .subscribe((response) => {
        this.planProduction = response.one;
        this.isDataRetrieved = true;
        this.fetchUdpTeams();
        if (this.planProduction.typeEffectifEnum) {
          switch (this.planProduction.typeEffectifEnum) {
            case 'PREVISIONNEL':
              this.currentEffectif = 'Effectif prévisionnel';
              break;
            case 'FABRICATION':
              this.currentEffectif = 'Effectif de fabrication';
              break;
            case 'FACTURATION':
              this.currentEffectif = 'Effectif de facturation';
              break;
          }
        } else {
          this.currentEffectif = 'Effectif prévisionnel';
        }
        this.fetchFiltersListeBesoins();
        this.fetchDateFermeturePonctuelle();
      });
  }

  massiveTreamtmentSubscription = (): void => {
    this.massiveTreatmentSub = this.prodSvc.massiveTreatment$
      .subscribe((supplier: BulkDetailSupplier) => {
        const numberDishesToUpdate: any[] = [];
        const teamsDatesToUpdate: any[] = [];
        this.selectedDetails.forEach((detail: PlanProductionDetailDTO) => {
          if (supplier.nbParts !== undefined && supplier.nbParts !== null) numberDishesToUpdate.push({
            idLine: detail.id,
            subRecipe: detail.subRecipe,
            numbersDishes: supplier.nbParts
          });
          if (supplier.dateFab || supplier.dlc || supplier.udpEquipe) teamsDatesToUpdate.push({
            idLine: detail.id,
            subRecipe: detail.subRecipe,
            dateFab: supplier.dateFab,
            dateDlc: supplier.dlc,
            idUdpEquipe: supplier.udpEquipe?.id
          });
        });
        const tasks: any = {numberDishesToUpdate, teamsDatesToUpdate};
        this.prodSvc.applyMassiveTreatment(this.planProduction.id, tasks)
          .subscribe(() => {
            this.fetchPlanProductionSubscription()
            if (this.selectedDetails.some(d => d.hasSortie === true))
              this.toastSvc.displayToast(MSG_KEY.ROOT, MSG_SEVERITY.WARNING, `Certaines ou toutes les modifications n'ont pu être apportées car des sorties sont validées`);
          });
      })
  }

  dlcLessThanDateConsommation = (row: any): boolean => row.dlc < row.dateConso;

  dateFabricationLessOrEqualsThanDatePlanProduction = (row: any): boolean => row.dateFab <= this.planProduction.dateCreation;


  isDateFermeturePonctuelle = (row: any): boolean => {
    return this.fermeturePonctuelleSvc.isDateOnFermeturePonctuelle(row.dateFab, this.fermeturePonctuelleList);
  }

  fetchUdpTeams = (): void => {
    this.prodSvc.fetchUdpTeams(this.planProduction.id)
      .subscribe((res: ResponseWrapper<UniteDeProduction__EquipeDTO>) => {
        this.teams = res.resultList;
        this.dataSourceTeams = new DataSource({
          store: new ArrayStore({
            data: this.teams,
            key: 'id',
          }),
          group: 'zoneDeProductionLibelle',
        });
      });
  }

  genererListeBesoins = (): void => {
    this.typeGeneration = 'LISTE_BESOIN';
    this.displayOptionsGenerationListeBesoinDialog = true;
  }

  closeOptionsGenerationListeBesoin = (): void => {
    this.displayOptionsGenerationListeBesoinDialog = false;
  }

  simulationStock = () => {
    if (this.planProduction.id) {
      const date = this.planProduction.rows.reduce((a, b) =>
        new Date(a.dateConso).getTime() > new Date(b.dateConso).getTime() ? a : b).dateConso;
      if (date <= new Date()) {
        this.dateMin = new Date(date);
        this.dateMax = new Date();
      } else {
        this.dateMin = new Date();
        this.dateMax = new Date(date);
      }

      this.closeOptionsGenerationListeBesoin();
      this.loadingMessage = 'Simulation des stocks en cours...';
      this.loadingVisible = true;
      this.prodSvc.simulationStock(this.planProduction.id, this.idPlanProductionDetails)
        .pipe(finalize(() => this.loadingVisible = false))
        .subscribe((response) => {
          this.displaySimulationStocks = true;
          this.simulationStocks = response.resultList;
          this.simulationStocksInitial = response.resultList;
        })
    }
  }
  applyFiltersForGenerateListeBesoins = (usedSimulationStocks: boolean, forceGenerationListeBesoins?: boolean): void => {
    if (this.planProduction.id) {
      this.closeOptionsGenerationListeBesoin();
      if (forceGenerationListeBesoins) {
        this.displayDenreesWithoutItems = false;
      }
      this.loadingMessage = 'Génération de la liste de besoins...';
      this.loadingVisible = true;
      this.lbSvc.generateFromPlanProduction(this.planProduction.id, this.newLabelListeBesoin, {
        avoidQuantityZero: this.avoidQuantityZero,
        famillesProduitsIds: this.selectedFamillesPlats,
        fournisseursIds: this.idsFournisseursSelected,
        typesApprovisionnementIds: this.idsTachesSelected,
        idPlanProductionDetails: this.idPlanProductionDetails,
        forceGenerationListeBesoins: forceGenerationListeBesoins
      }, usedSimulationStocks)
        .pipe(finalize(() => this.loadingVisible = false))
        .subscribe((res: ResponseWrapper<ListeBesoinsDto>) => {
          const allDenreesProblematiques = [...(res.one.denreesWithoutItems || []), ...(res.one.denreesHorsSaison || []), ...(res.one.denreesCatalogueAchatPeriodeInactive || [])];
          if (forceGenerationListeBesoins && !res.one.workflowInstance) {
            this.toastSvc.displayToast(MSG_KEY.ROOT, MSG_SEVERITY.WARNING, `Aucune liste ne peut être générée car aucun besoin n'est détecté`);
          } else if (allDenreesProblematiques.length) {
            this.titleButtonForceGeneration = 'Forcer la génération de la liste de besoins';
            this.displayDenreesWithoutItems = true;
            this.denreesWithoutItems = allDenreesProblematiques.map(pd => ({
              ...pd,
              url: `/gestion-production/pp/plans-de-production(secondary:gestionproduits/produit/false/${pd.produit.id}/articles)?idUdp=${pd.idUniteProduction}`
            }));
          } else {
            this.routeMapSvc.goToSecondaryRoute(['gestion-processus', res.one.workflowInstance.id, 'lb-details', 'articles']);
          }
        });
    }
  }

  onChangeFournisseur = (data: any): void => {
    this.idsFournisseursSelected = data;
  }

  onChangeTache = (data: any): void => {
    this.idsTachesSelected = data;
  }

  onChangeParentFamilleProduitSelection = (data: any): void => {
    this.selectedFamillesPlats = data;
  }

  getIdFamilleProduitListSelected = (idList: number[]): number[] => {
    let result = [];

    idList.forEach(id => {
      this.famillesPlats.forEach(fp => {
        if (!this.utils.isNullOrEmpty(fp.parent) && fp.parent.id === id) {
          result.push(fp.id);
          result = [...result].concat(this.reflexionSearchId([...this.famillesPlats], fp.id));
        }
      })
    });

    result = [...result].concat(idList);
    return [...new Set(result)];
  }

  reflexionSearchId = (familleProduitList: FamilleProduitDTO[], idSearch: number): number[] => {
    let idResultList: number[] = [];
    familleProduitList.forEach(item => {
      if (!this.utils.isNullOrEmpty(item.parent) && item.parent.id === idSearch) {
        idResultList.push(item.id);
        idResultList = [...idResultList].concat(this.reflexionSearchId([...familleProduitList], item.id));
      }
    });
    return idResultList;
  }

  isEditable = (): boolean => this.auth2Svc.isSiteLocal(this.planProduction?.site?.id) && this.valueConsumptionDate && this.valueMeal && this.valuePlc && this.valueTeam;

  isColumnTeamVisible = (): boolean => this.planProduction?.rows[0]?.equipe !== undefined && this.planProduction?.rows[0]?.equipe !== null;

  isColumnPlcVisible = (): boolean => this.planProduction?.rows[0]?.pointDeLivraisonClient !== undefined && this.planProduction?.rows[0]?.pointDeLivraisonClient !== null;

  isColumnMealVisible = (): boolean => this.planProduction?.rows[0]?.repas !== undefined && this.planProduction?.rows[0]?.repas !== null;

  isColumnConsumptionDateVisible = (): boolean => this.planProduction?.rows[0]?.dateConso !== undefined && this.planProduction?.rows[0]?.dateConso !== null;

  getToolTipEffectifsZero = (cell: any): string => {
    return 'Attention, les effectifs sont à zéro';
  }

  getToolTipDlc = (cell: any): string => {
    let tooltip: string = 'Attention, la DLC est inférieure à la date de consommation';
    const offsetDay = (Math.abs(cell.row.data.dateFab - cell.row.data.dlc)) / (1000 * 60 * 60 * 24);
    if (offsetDay > cell.row.data.produitDeclinaison.dlc) {
      const datePreco = new Date(cell.row.data.dateFab);
      datePreco.setDate(datePreco.getDate() + cell.row.data.produitDeclinaison.dlc);
      tooltip += 'Attention, la DLC saisie est supérieure à la DLC autorisée par le plat (DLC préconisée : ' + datePreco.toLocaleDateString() + ')';
    }
    return tooltip;
  };

  goToProductPage = (idProduct: number) => this.routeMapSvc.goToSecondaryRoute([FP_ROUTES.GPR, 'produit', 'true', idProduct, 'fichetechnique']);

  openBulkEditionDetailDialog = () => {
    this.prodSvc.announceOpenMassiveTreatmentDialog({
      udpEquipeList: this.teams
    });
  };

  openPreparationConditionnement = (refresh?: boolean) => {
    if (this.planProduction.id) {
      this.loadingMessage = 'Chargement des préparations de conditionnement...';
      this.loadingVisible = true;
      from(this.routeMapSvc.goToSecondaryRoute([FS_ROUTES.GESTION_PREPARATION_CONDITIONNEMENTS, this.planProduction.id, refresh ? 'true' : 'false', 'calcul']))
        .pipe(finalize(() => this.loadingVisible = false))
        .subscribe();
    }
  };

  generateOrShowSortiesPlanProduction(forceGenerationListeBesoins?: boolean) {
    if (this.planProduction.hasSortieValidee) {
      this.routeMapSvc.goToSecondaryRoute(['steps', 'sorties-production', this.planProduction.id]);
    }
    else {
      this.generateSortiesPlanProduction(forceGenerationListeBesoins);
    }
  }

  generateSortiesPlanProduction = (forceGenerationListeBesoins?: boolean): void => {
    this.typeGeneration = 'SORTIES_PRODUCTION';
    if (forceGenerationListeBesoins) {
      this.displayDenreesWithoutItems = false;
    }
    this.loadingMessage = 'Génération des sorties de production...';
    this.loadingVisible = true;
    this.prodSvc.generateSortiesPlanProduction(this.planProduction.id, forceGenerationListeBesoins)
      .pipe(finalize(() => this.loadingVisible = false))
      .subscribe((res) => {
        if (res.one.denreesWithoutItemsForSorties && res.one.denreesWithoutItemsForSorties.length) {
          this.titleButtonForceGeneration = 'Forcer la génération des sorties de production';
          this.displayDenreesWithoutItems = true;
          this.denreesWithoutItems = res.one.denreesWithoutItemsForSorties.map(pd => ({
            ...pd,
            url: `/gestion-production/pp/plans-de-production(secondary:gestionproduits/produit/false/${pd.produit.id}/articles)?idUdp=${pd.idUniteProduction}`
          }));
        } else if (res.one.denreesWithRatiosMisconfigured?.length) {
          this.displayDenreesWithRatiosMisconfigured = true;
          this.denreesWithRatiosMisconfigured = res.one.denreesWithRatiosMisconfigured.map(d => {
            d.url = `/gestionproduits(secondary:gestionproduits/produit/false/${d.produitId}/articles/infos)?idUdp=${d.uniteDeProductionId}`;
            return d;
          });
        } else {
          this.routeMapSvc.goToSecondaryRoute(['steps', 'sorties-production', this.planProduction.id]);
        }
      });
  }

  previousStep = () => {
    this.routeMapSvc.goToSecondaryRoute(['steps', 'selection-filters', this.planProduction.id]);
  }

  refreshPlanProduction = () => {
    this.prodSvc.refreshPlanProduction(this.planProduction.id).subscribe((response) =>
      this.planProduction = response.one);
  }

  onSelectionChanged = (event: any): void => {
    this.selectedDetails = event.selectedRowsData
    this.idPlanProductionDetails = event.selectedRowsData.map(r => {
      return r.id
    });
  };

  openPrintSettingsFichesTechniques = () => {
    this.displayPrintSettingsFichesTechniques = false;
    this.prodSvc.getPrintSettings(this.planProduction.id, true)
      .subscribe(response => {
        if (response) {
          const res: any = response.one;
          this.datesFab = res.datesAvailable.datesFabrication;
          this.datesConso = res.datesAvailable.datesConsommation;
          this.displayPrintSettingsFichesTechniques = true;
        }
      });
  }

  onEditingStart = (event: any) => {
    this.updateLoadingPopup();
    if (event.data?.hasSortie === true) {
      this.toastSvc.displayToast(MSG_KEY.ROOT, MSG_SEVERITY.WARNING, `Certaines ou toutes les modifications ne peuvent pas être apportées car des sorties sont validées`);
    }
  };

  onCellPrepared = (event: any) => {
    this.updateLoadingPopup();
    if (event.rowType === DATAGRID_ROW_TYPES.HEADER && this.isEditable()) {
      if (event.column.allowEditing === true) {
        event.cellElement.style.backgroundColor = UI_COLORS.EDITABLE;
      }
    }

    if (event.rowType === DATAGRID_ROW_TYPES.DATA && event.column.dataField === this.columnNameNbParts && event.data?.nbPartsModifiedManually) {
      event.cellElement.addEventListener('mouseenter', () => {
        this.tooltipData = 'Valeur initiale : ' + event.data?.nbPartsInitial + ' ' + event.data?.produitDeclinaison.uniteDeMesure.abreviation
        this.tooltipTarget = event.cellElement;
        this.tooltipVisible = true;
      });
      event.cellElement.addEventListener('mouseleave', () => {
        this.tooltipVisible = false;
      });
    }

    if (!this.utils.isNullOrEmpty(event.data?.nbPartsArrondi)) {
      if (event.rowType === DATAGRID_ROW_TYPES.DATA && event.column.dataField === this.columnNameNbPartsArrondi && event.data?.reste.id === 2 && event.data?.nbPartsArrondi > 0) event.cellElement.style.backgroundColor = UI_COLORS.EFFECTIF_CONDI_SUPERIEUR;
      if (event.rowType === DATAGRID_ROW_TYPES.DATA && event.column.dataField === this.columnNameNbPartsArrondi && event.data?.reste.id === 3 && event.data?.nbPartsArrondi > 0) event.cellElement.style.backgroundColor = UI_COLORS.EFFECTIF_CONDI_INFERIEUR;
    }
    if (event.rowType === DATAGRID_ROW_TYPES.DATA && event.column.dataField === this.columnNameNbParts && event.data?.nbPartsModifiedManually) event.cellElement.style.backgroundColor = UI_COLORS.MODIFICATION_MANUELLE;
    if (event.rowType === DATAGRID_ROW_TYPES.DATA && event.column.dataField === this.columnNameNbPartsArrondi && event.data?.nbPartsModifiedManually) event.cellElement.style.backgroundColor = UI_COLORS.MODIFICATION_MANUELLE;
    if (event.rowType === DATAGRID_ROW_TYPES.DATA && event.column.dataField === this.columnNameEquipe && event.data?.idUdpEquipeModifiedManually) event.cellElement.style.backgroundColor = UI_COLORS.MODIFICATION_MANUELLE;
    if (event.rowType === DATAGRID_ROW_TYPES.DATA && event.column.dataField === this.columnNameDateFab && event.data?.dateFabModifiedManually) event.cellElement.style.backgroundColor = UI_COLORS.MODIFICATION_MANUELLE;
    if (event.rowType === DATAGRID_ROW_TYPES.DATA && event.column.dataField === this.columnNameDateDlc && event.data?.dateDlcModifiedManually) event.cellElement.style.backgroundColor = UI_COLORS.MODIFICATION_MANUELLE;
  };

  closeDenreesWithoutItems() {
    this.displayDenreesWithoutItems = false;
  }

  closeDenreesWithRatiosMisconfigured() {
    this.displayDenreesWithRatiosMisconfigured = false;
  }

  private updateLoadingPopup = () => {
    if (this.grid) {
      if (!this.isDataRetrieved) {
        if (!this.isPopupOpened)
          this.grid.instance.beginCustomLoading("Chargement en cours");
        this.isPopupOpened = true;
      } else {
        this.grid.instance.endCustomLoading();
        this.isPopupOpened = false;
      }
    }
  }

  onInitialized = () => {
    this.updateLoadingPopup();
  };

  onExporting = (e: any) => {
    const workbook = new Workbook();
    const worksheet = workbook.addWorksheet();

    exportDataGrid({
      component: e.component,
      worksheet,
      autoFilterEnabled: true,
      customizeCell: (options) => {
        const {gridCell, excelCell} = options;
        if (gridCell.rowType === 'data') {
          if (gridCell.column.dataField === 'nbPartsArrondi') {
            excelCell.value = this.utils.isNullOrEmpty(gridCell.data.nbPartsArrondi) ?
              gridCell.data.nbParts : gridCell.data.nbPartsArrondi;
          }
        }
      }
    }).then(() => {
      workbook.xlsx.writeBuffer().then((buffer) => {
        saveAs(new Blob([buffer], {type: 'application/octet-stream'}), this.planProduction.libelle + '.xlsx');
      });
    });
  };

  goToUrl = (url: string) => {
    window.open(url, '_blank');
  }

  closeSimulationStock = () => {
    this.searchDenree = null;
    this.displaySimulationStocks = false;
  }

  onClick = ($event: any) => {
    this.selectedSimulationStock = $event.itemData;
  }

  valueChanged = ($event: any) => {
    this.searchDenree = $event.value;
    this.simulationStocks = this.simulationStocksInitial.filter(item => item.produitDeclinaison.libelle.toLowerCase().includes($event.value));
  }

  handlePageChange = event => {
    this.page = event;
  };

  closeErrors(): void {
    this.displayBonErrors = false;
    this.displayDateConditionnementErrorList = false;
    this.livraisonDateErrorList = [];
    this.selectedLivraisonDateErrors = [];
    this.bulkSwitchingDate = null;
  }

  printLivraison = () => {
    this.printMenuSvc.announceDisplayPrintBonlivraison();
  };

  printAllotissement = () => {
    this.printMenuSvc.announceDisplayPrintBonAllotissement();
  };

  private initPrintErrors = () => {
    this.subPrintErrorsBonlivraison = this.pcSvc.printErrorsBonlivraison$.subscribe((response) => {
      this.printErrors = response.platsErreurs;
      if (response.platsErreurs.length > 0)
        this.displayBonErrors = true;
      this.popupErrorsTitle = 'Erreurs lors de la génération du bon de livraison';
      this.idPlanProduction = response.idPlanProduction;
      this.printMode = response.printMode;
      this.settings = response.settings;
      this.printSubject = PRINT_SUBJECT.BON_LIVRAISON;
      this.conditionnementDateErrorList = response.conditionnementDateErrorList || [];
      this.livraisonDateErrorList = response.livraisonDateErrorList || [];
      this.displayDateConditionnementErrorList = this.livraisonDateErrorList.length > 0;
      this.displayConditionnementDateErrorMessage = response.conditionnementDateErrorList.length > 0;
      this.selectedLivraisonDateErrors = [];
      this.bulkSwitchingDate = null;
    })

    this.subPrintErrorsBonAllotissement = this.pcSvc.printErrorsBonAllotissement$.subscribe((response) => {
      this.printSubject = PRINT_SUBJECT.BON_ALLOTISSEMENT;
      this.bonAllotissementSettings = response.settings;
      this.printErrors = response.platsErreurs;
      this.displayBonErrors = response.platsErreurs.length > 0;
      this.displayConditionnementDateErrorMessage = response.conditionnementDateErrorList.length > 0;
      this.displayLivraisonDateErrorMessage = response.livraisonDateErrorList.length > 0;
    })
}

  forcePrint = () => {
    if (this.printSubject == PRINT_SUBJECT.BON_LIVRAISON) {
      this.settings.switchDatesByCombination = this.livraisonDateErrorList.filter(dateError => dateError.switchingDate != null);
      this.preparationConditionnementSvc.printBonLivraison(this.idPlanProduction, this.settings, this.printMode, true)
        .pipe(takeUntilDestroyed(this.$destroyRef))
        .subscribe();
    }
    else {
      this.bonAllotissementSettings.force = true;
      this.preparationConditionnementSvc.printBonAllotissement(this.bonAllotissementSettings)
        .pipe(takeUntilDestroyed(this.$destroyRef))
        .subscribe();
    }
    this.displayConditionnementDateErrorMessage = false;
    this.displayLivraisonDateErrorMessage = false;
    this.displayDateConditionnementErrorList = false;
    this.livraisonDateErrorList = [];
    this.displayBonErrors = false;
    this.selectedLivraisonDateErrors = [];
    this.bulkSwitchingDate = null;
  };

  onLivraisonErrorSelectionChanged(event: any): void {
    this.selectedLivraisonDateErrors = event.selectedRowsData;
  }

  applyBulkSwitchingDate(): void {
    if (!this.bulkSwitchingDate || this.selectedLivraisonDateErrors.length === 0) {
      return;
    }
    this.selectedLivraisonDateErrors.forEach(row => row.switchingDate = this.bulkSwitchingDate);
    this.livraisonDateErrorList = [...this.livraisonDateErrorList];
  }

  tooltip = (step: StepSimulationStockDTO) => {
    if (step.listeBesoinLibelle) return step.listeBesoinLibelle;
    else if (step.planProductionLibelle) return step.planProductionLibelle;
    else return '';
  };

  setDefaultValue = (rowData) => {
    return rowData.regimeLibelle != null ? rowData.regimeLibelle : '-';
  };

  initHasGestionIDistri = (): void => {
    this.auth2Svc.hasGestionIDistri$.subscribe(response => this.hasIDistri = response);
  };

  printRecapCondi() {
    this.pcSvc.announcePrintConditionnement();
  }

  getDiff(data: any): number {
    return data.nbPartsArrondiOrNbParts - data.quantiteSource;
  }

  diff(cell: any): string {
    const data = cell.row.data;
    let diff = (data.nbPartsArrondiOrNbParts - data.quantiteSource);
    diff = Math.round((diff + Number.EPSILON) * 100) / 100
    return diff > 0 ? `+${diff}` : `${diff}`;
  }

  changeModeDifferentielSelected = () => {
    const selectedLines: boolean = this.checkSelectedLines();
    if (!selectedLines) return;
    const planProductionLignesSelectedIdList = this.selectedDetails.map(detail => detail.id);
    const modeDifferentiel: boolean = !this.selectedDetails.every(r => r.modeDifferentiel === true);
    this.prodSvc.updateModeDifferentielSelectedLines(planProductionLignesSelectedIdList, modeDifferentiel).subscribe((res) => {
      if (res) {
        this.planProduction.rows
          .filter(r => planProductionLignesSelectedIdList.includes(r.id))
          .forEach(r => r.modeDifferentiel = modeDifferentiel);
        this.toastSvc.displayToast(MSG_KEY.ROOT, MSG_SEVERITY.SUCCESS, `Mode différentiel mis à jour pour les lignes sélectionnées`);
        this.gridDetailPlanProd.instance.refresh();
      }
    })
  }

  deleteLignesPlanProduction = async () => {
    const selectedLines: boolean = this.checkSelectedLines();
    if (!selectedLines) return;
    const result = confirm(`Etes vous sûr de vouloir supprimer les lignes sélectionnées du plan de production ?`,
      'Suprression de conditionnement variant');
    const isDeleted: boolean = await result;
    const idLignesToDelete = this.selectedDetails.map(detail => detail.id);
    if (isDeleted) {
      this.prodSvc.deleteLignesFromPlanProduction(idLignesToDelete).subscribe((res) => {
        if (res) {
          this.planProduction.rows = this.planProduction.rows.filter(row => !idLignesToDelete.includes(row.id));
          this.toastSvc.displayToast(MSG_KEY.ROOT, MSG_SEVERITY.SUCCESS, `Suppression réalisée avec succès`);
          this.gridDetailPlanProd.instance.refresh();
        }
      });
    }
  };

  checkSelectedLines = () => {
    const selectedLines = this.selectedDetails.length > 0;
    if (!selectedLines) {
      this.toastSvc.displayToast(MSG_KEY.ROOT, MSG_SEVERITY.WARNING, `Aucune ligne sélectionnée`);
    }
    return selectedLines;
  }

  startCalculation = () => {
    this.loadingMessage = 'Calcul en cours...';
    this.loadingVisible = true;
    this.subscriptionCalcul = this.pcSvc.startCalculation(this.planProduction.id, true)
      .subscribe(data => {
          const res: any = data;
          if (res.one?.reports?.length > 0)
            this.prodSvc.announceDisplayCalculCondiErrors(res.one.reports);
          else
            this.displayCalculSuccess = true;
          this.loadingVisible = false;
        }
      );
  };

  getDisabledDateLivraison = (data) => {
    return this.fermeturePonctuelleSvc.isDateOnFermeturePonctuelle(data.date, this.fermeturePonctuelleList)
  };

}
